import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Icon } from '@/kit/Icon';
import './LimitedCompanyMenu.scss';

interface MenuLink {
  to: string;
  /** BUG-066: the FRS102 route also serves Section 1A as `?section=1A`. */
  section?: string;
  label: string;
}

const LINKS: MenuLink[] = [
  { to: '/home/settings/limited-company', label: 'UK-GAAP' },
  { to: '/home/settings/limited-company-FRS102', label: 'FRS102' },
  { to: '/home/settings/limited-company-FRS102', section: '1A', label: 'FRS102 Section 1A' },
  { to: '/home/settings/limited-company-FRS105', label: 'FRS105' },
];

/**
 * Angular LimitedCompanyMenuComponent: the UK-GAAP / FRS102 / FRS105 chooser of the three limited company screens.
 * It starts open (closeMenu false) so the framework choice is visible; the chevron collapses it and tells the host.
 */
export function LimitedCompanyMenu({ onToggleSideList }: { onToggleSideList: (closed: boolean) => void }) {
  const [closeMenu, setCloseMenu] = useState(false);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const section = new URLSearchParams(search).get('section') ?? undefined;

  const menuToggle = () => {
    const closed = !closeMenu;
    setCloseMenu(closed);
    onToggleSideList(closed);
    window.dispatchEvent(new Event('resize'));
  };

  return (
    <div className="limited-company-menu">
      <div className="d-flex h-100">
        <div className={`side-list side-list-menu ${closeMenu ? 'hide-sidelist' : ''}`.trim()}>
          <div className="side-list-wrapper h-100">
            <ul>
              {LINKS.map((link) => (
                <li
                  key={link.label}
                  role="link"
                  className={pathname === link.to && section === link.section ? 'active' : undefined}
                  onClick={() => void navigate(link.section ? `${link.to}?section=${link.section}` : link.to)}
                >
                  <Icon name="person_outline" outlined />
                  {link.label}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className={`menu-toggle menu-side-toggle ${closeMenu ? 'toggle-icon' : ''}`.trim()} onClick={menuToggle}>
        <Icon name={closeMenu ? 'keyboard_arrow_right' : 'keyboard_arrow_left'} />
      </div>
    </div>
  );
}
